import { useEffect, useState } from 'react';

type TPropsTimer = {
    time: string;
    timeUpdate: number;
    onUpdate: (time: string) => string;
    shouldWork?: boolean;
};

export const useTimer = ({ time, onUpdate, timeUpdate, shouldWork = true }: TPropsTimer): { message: string } => {
    const [message, setMessage] = useState<string>('');

    const [firstUpdate, setFirstUpdate] = useState<boolean>(true);

    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let timeout: any;

        if (timeUpdate) {
            timeout = setInterval(
                () => {
                    const mess = onUpdate(time);

                    setMessage(mess);

                    if (firstUpdate) {
                        setFirstUpdate(false);
                    }
                },
                firstUpdate ? 0 : timeUpdate * 1000,
            );
        }

        return () => clearInterval(timeout);
    }, [firstUpdate]);

    if (!shouldWork) return { message };

    return { message };
};
